export default ({ app, $sitewideData }) => {
    let isLoaded = false

    app.router.afterEach((to) => {
        // We only want Ella on the Careers page
        /* eslint-disable */
        // prettier-ignore
        if (!isLoaded && $sitewideData.config.ellaEnabled && to.path === '/careers/') {
            window.oliviaChatData = window.oliviaChatData || []
            window.oliviaChatBaseUrl = 'https://olivia.paradox.ai'
            window.oliviaChatData.push(['setKey', $sitewideData.config.ellaKey])
            window.oliviaChatData.push(['start'])
            ;(function () {
                var apply = document.createElement('script')
                apply.type = 'text/javascript'
                apply.async = true
                apply.src = 'https://dokumfe7mps0i.cloudfront.net/static/site/js/widget-client.js'
                var s = document.getElementsByTagName('script')[0]
                s.parentNode.insertBefore(apply, s)
            })()

            isLoaded = true
        }
    })
}
